import resendVerificationEmail from '@commonJs/actions/resendVerificationEmail';

$(document).on(
    'click',
    '#resend-verification-email',
    { uri: '/portal/api/resend-verification-email' },
    resendVerificationEmail
);
